<template>
  <div class="contents" >
    <nyTit1 pathUrl="/shangcaixq1" />
    <!-- 下部分内容开始 -->
    <div class="xia_content">
      <!-- 第1块开始 -->
      <div class="first1">
        <!-- 第1块上部分 -->
        <div class="first1_top">
          <!-- 标题区域 -->
          <div class="title"><span class="txt1">{{state.font1.name}}</span><span class="txt2">Introduction to Shangcai County</span></div>
          <!-- 标题区域 -->
          <!-- 第一块内容区域 -->
          <div class="content_bt_qy">
            <img  class="first1_top_down_img"  src="../assets/img/shancaixianqing/xq/xczp.png"  />
            <div class="first1_top_down_jian_jie" v-on:mouseover="changeActive(0)" v-on:mouseout="removeActive(0)">  
              <p>{{state.font1.info}}</p>
              <bigFont leftMargin="80%" topMargin="0" :txt="state.font1.info" :title="state.font1.name" :isShow="state.curIndex[0]"/>
            </div>
            
          </div>
          <!-- 第一块内容区域 -->
        </div>
        <!-- 第1块上部分 -->
        <!-- 第1块下部分 -->
        <div class="first1_down">
          <!-- <div class="title"><span class="txt1">历史悠久 底蕴深厚</span></div> -->
          <img src="../assets/img/shancaixianqing/xq/sc.png" />
        </div>
        <!-- 第1块下部分 -->
      </div>
      <!-- 第1块 结束-->
      <!-- 第2块开始 -->
      <div class="first2">
        <div class="first2_box1">
          <div class="title"><span class="txt1">{{state.font2.name}}</span></div>
          <div class="first2_box1_content">
            <div class="first2_box1_txt fontStyle" v-on:mouseover="changeActive(1)" v-on:mouseout="removeActive(1)">
              <p>{{state.font2.info}}</p>
              <bigFont leftMargin="-110%" topMargin="0" :txt="state.font2.info" :title="state.font2.name" :isShow="state.curIndex[1]"  />
            </div>
            <div class="first2_box1_r">
              <div class="first2_box1_r_item" v-for="(item,index) in state.left_right" :key="index">
                <span class="first2_box1_r_item_a">{{item.txt}}</span><span class="first2_box1_r_item_b">{{item.txt1}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="first2_box2">
          <div class="title"><span class="txt1">资源丰富、优势明显</span></div>
          <div class="first2_box2_content">
            <div class="first2_box2_content_item" v-for="(item,index) in state.left_right_b" :key="index" v-on:mouseover="changeActive(index+2)" v-on:mouseout="removeActive(index+2)">
              <div class="first2_box2_content_item_l">
                <h5>{{item.name}}</h5>
                  <p class="">{{item.intro}}</p>
                  
                <bigFont leftMargin="-80%" topMargin="-100%" :txt="item.intro" :title="item.name" :isShow="state.curIndex[index+2]"  />
              </div>
              <img :src="item.img" />
            </div>
          </div>
        </div>
      </div>
      <!--  第2块 结束-->
      <!-- 第3块 开始-->
      <div class="first3">

        <div class="first3Box">
          <div class="videoBox">
          <div class="shiptz">
            <vue3VideoPlay ref="videoPlayer"  loop  color="#ff0000"  width="100%"  height="100%"  title="冰河世纪"  :src="state.options.src"  :type="state.options.type"  :autoPlay="true"  @play="onPlay"/>
            <!-- <button @click="muteVideo"  class="jingyin">静音</button> -->
          </div>
          </div>
        </div>
      </div>
      
      <!-- 第3块结束-->
      <!-- 第4块 开始-->
      <div class="first4">
        <div class="title"><span class="txt1">产业明晰 发展良好</span><span class="txt2">The industry is clear and well developed</span></div>
        <div class="first4_box1"><rightPie :rightPie="state.rightPie" /></div>
        <div class="first4_box2">
          <h3>三大主导产业</h3>
          <div class="first4_box2_c">
            <div class="first2_box2_content_item" v-for="(item,index) in state.right_left_b" :key="index"  v-on:mouseover="changeActive(index+5)" v-on:mouseout="removeActive(index+5)">
              <div class="first2_box2_content_item_l">
                <h5>{{item.name}}</h5>
                <p class="">{{item.intro}}</p>
                <bigFont leftMargin="80%" topMargin="-100%" :txt="item.intro" :title="item.name" :isShow="state.curIndex[index+5]"  />
              </div>
              <img :src="item.img" />
            </div>
          </div>
        </div>
      </div>
      <!--  第4块结束 -->
      <!-- 第5块开始 -->
      <div class="first5">
        <div class="title"><span class="txt1">政策优惠 环境一流</span></div>
        <div class="first5_box">
          <div class="first5_box_item" v-for="(item,index) in state.right_right" :key="index" v-on:mouseover="changeActive(index+8)" v-on:mouseout="removeActive(index+8)">
            <h5>{{item.name}}</h5>
            <p>{{item.intro}}</p>
            <img :src="item.img" />
            <bigFont leftMargin="-100%" topMargin="0" :txt="item.intro" :title="item.name" :isShow="state.curIndex[index+8]"  />
          </div>
        </div>
      </div>
      <!-- 第5块结束 -->
    </div>
    <!-- 下部分内容结束 -->
  </div>
  <footer1 />
</template>

<script setup>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  onBeforeUnmount,
  getCurrentInstance,
} from "vue";
// import waterimg from "@/assets/img/xaiofei/fk.png"

import nyTit1 from '../components/nyTit1.vue'
import countTo from "@/components/vue-count-to/src/vue-countTo.vue";
import rightPie from '../components/shangcaixq/right_pie'
import bigFont from '../components/bigFont.vue'
import footer1 from "../components/footer.vue";
  name: "Home";
  const videoPlayer = ref(null);
  const { proxy } = getCurrentInstance();
  // const timer = ref(null);
  const router = useRouter();
  const state = reactive({
    url: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img",
    currentTime: "",
    font1:{
      name:"上蔡县介绍",
      info: "上蔡县位于河南省东南部、驻马店市东北部，古为蔡国，是海内外蔡氏祖地，秦丞相李斯故里、中国重阳文化之乡。现辖26个乡镇（街道）、 460个行政村（社区），总人口160.77万人，常住人口100.57万人，土地面积1529平方公里，耕地面积165.6万亩，是全国超级产粮大县、全国粮食生产百强县、全国生猪调出大县、全国城乡交通一体化示范县、全国尊老敬老模范县、国家卫生县城，也是省级文明城市、省级园林县城、河南省法治县、河南省平安建设优秀县。",
    },
     font2:{
      name:"历史悠久 底蕴深厚",
      info: "上古时期，人文始祖伏羲因蓍草生于蔡地，画卦于蔡河之滨，遂名其地为“蔡”。公元前11世纪，周武王封其弟叔度于蔡，建立蔡国，距今已有3000多年历史，是联合国地名组织命名的“千年古县”、海内外蔡氏祖地、秦丞相李斯故里、中国重阳文化之乡。",
    },
    curIndex:[false,false,false,false,false,false,false,false,false],
    left_right:[{txt:"一城",txt1:"蔡国古城"},{txt:"一人",txt1:"秦相李斯"},{txt:"一文化",txt1:"重阳文化"}],
    // ,{txt:"一姓",txt1:"蔡姓"}
    left_right_b:[
      {name:"交通区位优",intro:"地处驻马店、漯河、周口三市之间，距离三市均不超过50分钟车程。境内有4条高速、2条国道、7条省道，拥有11个高速出口，是全国交通运输一体化示范县。",img:require("../assets/img/shancaixianqing/xq/jt.png")},
      {name:"资源禀赋足",intro:"素有豫南“粮仓”之称，盛产小麦、玉米、芝麻、油菜、花生等农副产品；地热田面积大、埋层浅、储层厚；青电入豫工程驻马店换流站所在地，生物发电、光伏发电、风力发电发展迅速，具有良好的电力供应保障能力。",img:require("../assets/img/shancaixianqing/xq/zy.png")},
      {name:"市场规模大",intro:"以县城为中心，1小时经济圈辐射人口7000万，2小时经济圈辐射人口2亿人，周边500公里经济圈覆盖中国11个省市、648个县区、5亿多人，具有巨大的市场消费潜力。",img:require("../assets/img/shancaixianqing/xq/img3.png")}
    ],
    rightPie:[
      { value: 287.5, name: "2023年全县生产总值" },
      { value: 54.57, name: "第一产业增加值" },
      { value: 93.51, name: "第二产业增加值" },
      { value: 139.44, name: "第三产业增加值" },
    ],
    right_left_b:[
      {name:"纺织服装制鞋",intro:"2023年产值达到48亿元，已入驻隆祺鞋业、金帝鞋业、荣辉鞋业等骨干企业60余家，建成河南省第二家鞋类产品质量监督检验中心，“中原鞋都”建设蔚然成势。",img:require("../assets/img/shancaixianqing/xq/sd.png")},
      {name:"农副产品加工",intro:"2023年产值达到40亿元，已入驻上农实业、闽商食品工业园等为代表的骨干企业30多家，培育出“旷华食品” “盛世粮油”等一批知名品牌。",img:require("../assets/img/shancaixianqing/xq/nf.png")},
      {name:"电子电器",intro:"2023年产值达到4亿元，招引入驻天乾电子、兰迪光电科技、沃诚电子、臻美印象等企业15家，新一代电子电器和信息技术产业初步集聚发展。",img:require("../assets/img/shancaixianqing/xq/dz.png")}
    ],
    right_right:[
      {name:"营商环境优良",intro:"深化“放管服效”改革，2339项政务服务事项全部实现“一网通办”，行政许可类审批时限压缩90%以上，营商环境评价位居全市第二名。",img:require("../assets/img/shancaixianqing/xq/ys.png")},
      {name:"招商政策优惠",intro:"出台了一系列招商引资促进政策，在用地支持、厂房租赁、金融支持、企业上市等方面给予来蔡企业最大限度的扶持，支持企业做大做强。",img:require("../assets/img/shancaixianqing/xq/zs.png")},
      {name:"助企服务优质",intro:"建立了“企业服务日”“政银企对接”等制度，对重点项目、重点企业实施县领导直接联系分包，为企业提供全方位、一站式、保姆式服务。",img:require("../assets/img/shancaixianqing/xq/zq.png")}
    ],
     options: {
      // src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/scxc.mp4", //视频源
      src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/1.mp4", //视频源
      //  src:"file:///C:/video/1.mp4",
      type: "video/mp4", //视频类型
    },
  });
  onMounted(() => {

    // setTimeout(()=>{
    //   muteVideo()
    // },5000)


  });
  onUnmounted(() => {
    // 清理资源
  });
  onBeforeUnmount(() => {
    // clearInterval(timer.value);
  });
  function muteVideo(){
    if (videoPlayer.value) {
        // 获取视频元素
        const video = videoPlayer.value.$el.querySelector('video');
        console.log(video)
        if (video) {
          // 切换静音状态
          video.muted = !video.muted;
          console.log("开声音")
          console.log( video.muted )
        }
      }
  }
  function removeActive(num){
    state.curIndex[num]= false
  }
  function changeActive(num){
    console.log(num)
   state.curIndex[num]=true
   console.log(state.curIndex)
  }
  // 返回上一页
  function clickReturn() {
    router.go(-1);
    console.log("上一页")
  }




</script >

<style lang="less" scoped>

#video1 .d-player-wrap {
  object-fit: cover;
  // background-color: #ff0000 !important;
  background-color: transparent !important; /* 设置背景色为透明 */
}
a{display: block;width: 100%;height: 100%;}
.contents {
  width: 100%;
  height: 100%;
  width: 100%;
  height: 100%;
  background: url("@{url}/img/xqbj1.png") no-repeat top center;
  background-size: 100% 100%;
  position: relative;
  overflow: hidden;
  .xia_content {
    width: 100%;
    height: calc(100% - 180px);
    // border: #fff 1px solid;
    margin-top: 180px;
    display: flex;
    padding-bottom: 150px;
    box-sizing: border-box;
    position: relative;
    z-index: 2;
    .first1 {
      width: 650px;
      height: 100%;
      display: flex;
      flex-direction: column;
      margin-left: 60px;
      .first1_top {
        width: 100%;
        height: 828px;
        position: relative;
        display: flex;
        flex-direction: column;
        background: url("../assets/img/shancaixianqing/xq/k1.png") no-repeat;
        box-sizing: border-box;
        background-size: 100% 100%!important;
        .content_bt_qy{
          width: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
          //  border: 1px solid #f00;
          .first1_top_down_img{
            width: 622px;
            height: 347px;
            margin: 20px auto 0;
          }
          .first1_top_down_jian_jie{
            width: 100%;
            height:380px;
            font-size: 30px;
            text-align: left;
            padding: 20px 30px;
            box-sizing: border-box;
            color: rgba(255,255,255,.7);
            line-height: 50px;
            text-indent: 2em;
            position: relative;
            cursor: pointer;  
            p{
              width: 100%;
              height: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 7;
            }
          }
        }
      }
      .first1_down {
        width: 100%;
        flex: 1;
        background: url("../assets/img/shancaixianqing/xq/k2.png") no-repeat;
        margin-top: 20px;
        background-size: 100% 100%!important;
        display: flex;
        flex-direction: column;
        align-items:center ;

        img{
          transform: scale(.98);
          margin: 20px auto 0;
        }
      }
    }
    .first2 {
      width: 856px;
      height: 100%;
      margin: 0 36px 0 24px;
      background: url("../assets/img/shancaixianqing/xq/k3.png") no-repeat;
      background-size: 100% 100%!important;
      display: flex;
      flex-direction: column;
      .first2_box1{
        width: 100%;
        height: 390px;
        display: flex;
        flex-direction: column;
        .first2_box1_content{
          width: 100%;
          height: 280px;
          display: flex;
          .first2_box1_txt{
            height: 100%;
            flex: 1;
            box-sizing: border-box;
            padding: 36px 30px 0;
            position: relative;
            box-sizing: border-box;
            cursor: pointer;
            p{
              width: 100%;
              height: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 5;
              
            }
          }
          .first2_box1_r{
            width: 270px;
            height: 100%;
            display: flex;
            flex-wrap: wrap;
            align-content: flex-start;
            align-items: center;
            justify-content: space-between;
            margin-right: 50px;
            .first2_box1_r_item{
              width: 111px;
              height: 151px;
              color: #00FFEA;
              margin:10px 0;
              span{display: block;}
              .first2_box1_r_item_a{
                width: 111px;
                height: 111px;
                background: url("../assets/img/shancaixianqing/xq/y.png") no-repeat;
                text-align: center;
                font-size: 24px;
                line-height: 111px;
              }
              .first2_box1_r_item_b{
                font-size: 24px;
                margin-top: 10px;
              }
            }
            .first2_box1_r_item:nth-child(1){
              width: 100%;
              .first2_box1_r_item_a{
                margin: 0 auto;
              }
            }
          }
        }
        
      }
      .first2_box2{
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        .first2_box2_content{
          width: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 30px 20px;
        }
      }
    }
    .first3 {
      flex: 1;
      height: calc(100% - 100px);
      background: url("../assets/img/shancaixianqing/xq/spk@2x.png") no-repeat;
      background-size: 100% 100%!important;
      margin-top: 100px;
      padding: 30px;
      box-sizing: border-box;
      overflow: hidden;
      .first3Box{
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
        .videoBox{
          width: 3436px;
           height: 1329px;
          //height: 1450px;
          position: absolute;
          top:-150px;
          left: -200px;
          border: 1px solid;
          .shiptz {
          width: 100%;
          height: 100%;
          position: relative;
          // top: 322px;
          overflow: hidden;
          .jingyin{
            position: absolute;
            top: 200px;
            left: 300px;
            z-index: 999;
            font-size: 40px;
          }
          }
        }
      }
      
    }
    

    .first4 {
      width: 854px;
      height: 100%;
      background: url("../assets/img/shancaixianqing/xq/k4.png") no-repeat;
      background-size: 100% 100%!important;
      margin: 0 30px;
      display: flex;
      flex-direction: column;
      .first4_box1{
        width: 100%;
        height: 380px;
      }
      .first4_box2{
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        padding-bottom: 40px;
        h3{
          font-size: 32px;
          background: linear-gradient(to bottom, #fff 25%, #abdfff 100%);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          font-style: italic;
          text-align: left;
          padding-left: 26px;
        }
        .first4_box2_c{
          width: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 20px 0;
        }
      }
    }
    .first5 {
      width: 679px;
      height: 100%;
      background: url("../assets/img/shancaixianqing/xq/k5.png") no-repeat;
      background-size: 100% 100%!important;
      margin-right: 50px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 0 30px;
      .first5_box{
        width: 100%;
        flex: 1; 
        .first5_box_item{
          width: 100%;
          font-size: 24px;
          text-align: left;
          color: #fff;
          margin-top: 50px;
          position: relative;
          cursor: pointer;
          h5{
            width: 100%;
            margin-bottom: 10px;
            font-size: 30px;
            
          }
          p{
            font-size: 30px;
            line-height: 50px;
            margin-bottom: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp:1;
          }
          img{
            width: 614px;
            height: 273px;
          }
        }
      }
     
    }
  }
  .first2_box2_content_item{
    height: 273px;
    display: flex;
    box-sizing: border-box;
    position: relative;
    cursor: pointer;
    .first2_box2_content_item_l{
      width: 400px;
      color: rgba(255,255,255,.8);
      font-size: 20px;
      display: flex;
      flex-direction: column;
      justify-content:center;
      margin: 0 10px;
      text-align: left;
      h5{
        width: 100%;
        margin-bottom: 10px;
        font-size: 36px;
        
      }
      p{
        font-size: 30px;
        line-height: 50px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        text-indent: 2em;      
      }
    }
    img{
      width: 384px;
    }
  }
  // 标题
  .title{
    width: 100%;
    height: 60px;
    padding-left: 50px;
    box-sizing: border-box;
    line-height: 60px;
    color: #fff;
    background: url("../assets/img/shancaixianqing/xq/bt1.png") no-repeat;
    display: flex;
    span{display: block;}
     .txt1 {
        font-size: 30px;
        background: linear-gradient(to bottom, #fff 25%, #abdfff 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-style: italic;
        font-weight: bold;
        padding: 0 10px;
      }
      .txt2 {
        color: #0287ba;
        margin-left: 20px;
        font-size: 22px;
        font-family: Arial, Helvetica, sans-serif;
      }
  }

  .fontStyle{
    font-size: 30px;
    text-align: left;
    padding: 20px 30px;
    color: rgba(255, 255, 255, 0.7);
    line-height: 50px;
    text-indent: 2em;
  }
}
</style>
